module.exports = __webpack_public_path__ + "static/media/app icon (1).0ff9be77.png";